import { render } from "./SessionsByChannelChart.vue?vue&type=template&id=26306cc5&ts=true"
import script from "./SessionsByChannelChart.vue?vue&type=script&lang=ts"
export * from "./SessionsByChannelChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__